<template>
  <div>
    <v-dialog max-width="1000" v-model="dialog">
      <template v-slot:activator="{ on }">
        <v-btn outlined small color="primary" v-on="on"
          >Import History</v-btn
        ></template
      >
      <v-card>
        <v-card-title primary-title>
          <v-toolbar elevation="0">
            <h1 class="mr-8 block">Import History</h1>
            <v-spacer></v-spacer>
            <v-btn icon small @click="dialog = false">
              <v-icon small>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-data-table
          disable-pagination
          :items="importFileList"
          :headers="[
            { text: 'Name', value: 'name' },
            { text: 'Uploaded By', value: 'uploadUserEmail' },
            {
              text: 'Uploaded At (YYYY/MM/DD, 24H Local Time)',
              value: 'createdLocal',
            },
            {
              text: '',
              value: 'id',
            },
          ]"
        >
          <template v-slot:item.id="{ value: fileId }"
            ><v-btn outlined text :href="`/api/file2/${fileId}/download`"
              >download
            </v-btn></template
          >
        </v-data-table>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  computed: {
    importFileList() {
      let fileList = this.getFileListByAttribute("fileTypeId", 7);

      fileList = fileList.map(file => {
        file.createdLocal = moment(file.created)
          .local()
          .format("YYYY/MM/DD, HH:MM:ss");

        return file;
      });

      return fileList;
    },
    ...mapGetters({
      getFileListByAttribute: "file2/filterByAttributeValue",
      getUserById: "user/getById",
    }),
  },
  async created() {
    const promiseList = [
      this.getFileList(),
      this.getUserList({ reload: false }),
    ];

    try {
      await Promise.all(promiseList);
    } catch (e) {
      console.error(e);
      this.$notifyError({ message: "Unable to load data from server" });
      return;
    }
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    ...mapActions({
      getFileList: "file2/list",
      getUserList: "user/list",
    }),
  },
};
</script>
